module.exports = __webpack_public_path__ + "static/media/home.ca203d8f.jpg";